import React from "react";
import { connect } from "react-redux";
import { addCartItem } from "../redux/actionCreators";
import ArticleControlContainer from "../ArticleControlContainer";
import ArticleControl from "../ArticleControl";
import SwipeableArticleCard from "../SwipeableArticleCard";
import { DoubleArrowLeft, DoubleArrowRight, Heart } from "../Icons";

const mapStateToProps = ({ auth, cart, ui }) => ({
  isLoggedIn: auth.authStatus.indication === "loaded",
  cartItemsCount: cart.cartItems.length,
  cartItems: cart.cartItems,
  showPrice: ui.showPrice,
  showUVP: ui.showUVP
});

const mapDispatchToProps = dispatch => ({
  addArticleToCart: article => dispatch(addCartItem(article))
});

function ArticleControls({
  onBack,
  onLike,
  onNext,
  fillHeart,
  leftOffset,
  rightOffset
}) {
  return (
    <ArticleControlContainer width="full">
      {leftOffset > 0 ? (
        <ArticleControl onClick={onBack}>
          <DoubleArrowLeft stroke="#6CB2EB" fill="#EFF8FF" />
        </ArticleControl>
      ) : (
        <div className="w-1/3" />
      )}
      <ArticleControl onClick={onLike}>
        <Heart fill={fillHeart ? "#51d88a" : undefined} />
      </ArticleControl>
      {rightOffset === 0 ? (
        <div className="w-1/3" />
      ) : (
        <ArticleControl onClick={onNext}>
          <DoubleArrowRight stroke="#6CB2EB" fill="#EFF8FF" />
        </ArticleControl>
      )}
    </ArticleControlContainer>
  );
}

class ArticleView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentArticleIndex: 0
    };
  }

  onLike = () => {
    const { articles, addArticleToCart, cartItems } = this.props;
    const { currentArticleIndex } = this.state;
    const articleToAddOrRemove = articles[currentArticleIndex];
    if (cartItems.includes(articleToAddOrRemove)) {
      return;
    }
    addArticleToCart(articleToAddOrRemove);
  };

  onNext = () => {
    const { articles, hasMore, refine } = this.props;
    const { currentArticleIndex } = this.state;
    if (currentArticleIndex === articles.length - 3 && hasMore) {
      refine();
    }
    this.setState({
      currentArticleIndex: Math.min(
        this.state.currentArticleIndex + 1,
        this.props.articles.length
      )
    });
  };

  onBack = () => {
    this.setState({
      currentArticleIndex: Math.max(this.state.currentArticleIndex - 1, 0)
    });
  };

  handleChangeIndex = index => {
    this.setState({
      currentArticleIndex: index
    });
  };

  render() {
    const {
      articles,
      cartItemsCount,
      cartItems,
      isLoggedIn,
      showUVP,
      showPrice
    } = this.props;
    const { currentArticleIndex } = this.state;
    let fillHeart;
    if (articles.length) {
      const currentArticle = articles[currentArticleIndex];
      fillHeart = false;

      if (cartItems.length) {
        fillHeart = cartItems
          .map(el => el.articleID)
          .includes(currentArticle.articleID);
      }
    }

    return (
      <div className="relative h-full w-full">
        <div style={{ height: "56px" }} className="absolute pin-b pin-l w-full">
          <ArticleControls
            leftOffset={currentArticleIndex}
            rightOffset={articles.length - 1 - currentArticleIndex}
            onLike={this.onLike}
            onNext={this.onNext}
            onBack={this.onBack}
            fillHeart={fillHeart}
          />
        </div>
        <div
          style={{
            paddingBottom: "56px"
          }}
          className="h-full w-full"
        >
          <SwipeableArticleCard
            articles={articles}
            currentArticleIndex={currentArticleIndex}
            onChangeIndex={this.handleChangeIndex}
            isLoggedIn={isLoggedIn}
            showPrice={showPrice}
            showUVP={showUVP}
          />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleView);



// WEBPACK FOOTER //
// ./src/ArticleView/ArticleView.js